import { createAction } from 'redux-actions';

import { SOCKET_EMIT } from '../communication/actions';

export const OPEN_CHAT = 'COMMUNICATION_OPEN_CHAT';
export const CLOSE_CHAT = 'COMMUNICATION_CLOSE_CHAT';
export const OPEN_CONVERSATION = 'COMMUNICATION_OPEN_CONVERSATION';
export const OPEN_CONVERSATION_SUCCESS = 'COMMUNICATION_OPEN_CONVERSATION_SUCCESS';
export const OPEN_CONVERSATION_FAILURE = 'COMMUNICATION_OPEN_CONVERSATION_FAILURE';
export const PENDING_CONVERSATION = 'COMMUNICATION_PENDING_CONVERSATION';
export const CLOSE_CONVERSATION = 'COMMUNICATION_CLOSE_CONVERSATION';
export const CLEAR_CONVERSATIONS = 'COMMUNICATION_CLEAR_CONVERSATIONS';
export const DISCARD_CONVERSATION = 'COMMUNICATION_DISCARD_CONVERSATION';
export const CHANGE_CHATTER_MESSAGE_STATUS = 'COMMUNICATION_CHANGE_CHATTER_MESSAGE_STATUS';
export const CHANGE_CHATTER_MESSAGE_STATUS_SUCCESS = 'COMMUNICATION_CHANGE_CHATTER_MESSAGE_STATUS_SUCCESS';
export const CHANGE_CHATTER_MESSAGE_STATUS_FAILURE = 'COMMUNICATION_CHANGE_CHATTER_MESSAGE_STATUS_FAILURE';
export const CLOSE_CUSTOMER_CHAT = 'COMMUNICATION_CLOSE_CUSTOMER_CHAT';
export const CLOSE_CUSTOMER_CHAT_PENDING = 'COMMUNICATION_CLOSE_CUSTOMER_CHAT_PENDING';
export const CLOSE_CUSTOMER_CHAT_SUCCESS = 'COMMUNICATION_CLOSE_CUSTOMER_CHAT_SUCCESS';
export const CLOSE_CUSTOMER_CHAT_FAILURE = 'COMMUNICATION_CLOSE_CUSTOMER_CHAT_FAILURE';
export const SEND_WELCOME_MESSAGE = 'COMMUNICATION_SEND_WELCOME_MESSAGE';
export const CHECK_CUSTOMER_AGENT = 'COMMUNICATION_CHECK_CUSTOMER_AGENT';
export const CHECK_CUSTOMER_AGENT_DONE = 'COMMUNICATION_CHECK_CUSTOMER_AGENT_DONE';
export const SET_CUSTOMER_AGENT = 'COMMUNICATION_SET_CUSTOMER_AGENT';

export const openChat = createAction(OPEN_CHAT, (username, isAnonymousUser, customerChatId, customerVideoCallId) => ({
  username,
  isAnonymousUser,
  customerChatId,
  customerVideoCallId,
}));
export const closeChat = createAction(CLOSE_CHAT);
export const openConversation = createAction(
  OPEN_CONVERSATION,
  (username, isAnonymousUser, customerChatId, customerVideoCallId) => ({
    username,
    isAnonymousUser,
    customerChatId,
    customerVideoCallId,
  })
);
export const openConversationSuccess = createAction(
  OPEN_CONVERSATION_SUCCESS,
  (username, history, { isAnonymousUser, customerChatId, customerVideoCallId }) => ({
    username,
    history,
    isAnonymousUser,
    customerChatId,
    customerVideoCallId,
  })
);
export const openConversationFailure = createAction(OPEN_CONVERSATION_FAILURE, error => ({
  error,
}));
export const pendingConversation = createAction(PENDING_CONVERSATION, pending => pending);
export const closeConversation = createAction(CLOSE_CONVERSATION);
export const clearConversations = createAction(CLEAR_CONVERSATIONS);
export const discardConversation = createAction(DISCARD_CONVERSATION, username => username);
export const changeChatterMessageStatus = createAction(CHANGE_CHATTER_MESSAGE_STATUS, (messageId, newStatus) => ({
  messageId,
  newStatus,
}));
export const changeChatterMessageStatusSuccess = createAction(
  CHANGE_CHATTER_MESSAGE_STATUS_SUCCESS,
  message => message
);

export const changeChatterMessageStatusFailure = createAction(CHANGE_CHATTER_MESSAGE_STATUS_FAILURE, error => ({
  error,
}));

export const sendMessage = createAction(SOCKET_EMIT, (to, message, data = null) => ({
  eventName: 'message',
  args: {
    to,
    message,
    ...(data
      ? {
          customerVideoCall: data.customerVideoCall,
          customerChat: data.customerChat,
          isAnonymousUser: data.isAnonymousUser,
          role: data.role,
        }
      : {}),
  },
}));

export const sendWelcomeMessage = createAction(
  SEND_WELCOME_MESSAGE,
  ({ username, isAnonymousUser, customerChat, customerVideoCall }) => ({
    username,
    isAnonymousUser,
    customerChat,
    customerVideoCall,
  })
);

export const endChatSocket = createAction(
  SOCKET_EMIT,
  ({ from, to, customerChatId, customerVideoChatId, isAnonymousUser }) => ({
    eventName: 'chat_ended',
    args: {
      from,
      to,
      customerChatId,
      customerVideoChatId,
      isAnonymousUser,
    },
  })
);
export const closeCustomerChat = createAction(CLOSE_CUSTOMER_CHAT, username => username);
export const closeCustomerChatPending = createAction(CLOSE_CUSTOMER_CHAT_PENDING, username => username);
export const closeCustomerChatSuccess = createAction(CLOSE_CUSTOMER_CHAT_SUCCESS, username => username);
export const closeCustomerChatFailure = createAction(CLOSE_CUSTOMER_CHAT_FAILURE, username => username);

export const checkCustomerAgent = createAction(CHECK_CUSTOMER_AGENT, () => 'check');
export const checkCustomerAgentDone = createAction(CHECK_CUSTOMER_AGENT_DONE);
export const setCustomerAgent = createAction(SET_CUSTOMER_AGENT, agent => agent);

export default {
  openChat,
  closeChat,
  openConversation,
  openConversationSuccess,
  openConversationFailure,
  pendingConversation,
  closeConversation,
  discardConversation,
  changeChatterMessageStatus,
  sendMessage,
  sendWelcomeMessage,
  changeChatterMessageStatusSuccess,
  changeChatterMessageStatusFailure,
  closeCustomerChat,
  checkCustomerAgent,
  setCustomerAgent,
  clearConversations,
};
